import type { ReactNode } from 'react'
import css from './InputIcon.module.css'

interface InputIconProps {
    icon: ReactNode
    disabled?: boolean
    onClick?: () => void
}

const InputIcon = ({ icon, disabled = false, onClick }: InputIconProps) => {
    const className = disabled ? `${css.input_icon} ${css.disabled}` : css.input_icon

    return (
        <div className={className} onClick={onClick}>
            {icon}
        </div>
    )
}

export default InputIcon
